<template>
  <div class="m-promotion">
    <h2 class="m-promotion__title">Congratulations</h2>
    <h3 class="m-promotion__subtitle">You have been promoted to</h3>
    <div class="u-align--center">
      <Rank class="m-rank--large"/>
    </div>
    <h2 class="m-promotion__title"></h2>
    <h5 class="m-promotion__title">Don’t forget to keep an eye on your budget!</h5>
    <a class="m-btn m-btn__secondary m-btn--right"
     @click="togglePromotion()"></a>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Rank from './header/Rank';

export default {
  components: {
    Rank,
  },
  computed: {
    ...mapGetters(['getRank']),
  },
  methods: {
    ...mapActions(['setShowPromotionStatus']),
    togglePromotion() {
      this.setShowPromotionStatus(false);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Promotion.vue